import JobOpeningLayout from '../components/Careers/components/JobOpeningLayout';
import { meta as foundingMarketingLead } from '../components/Careers/content/founding-marketing-lead';
import { publicMeta } from './public-meta';

export const meta = publicMeta(`${foundingMarketingLead.title} | Cartwheel`);

export default function FoundingMarketingLeadRoute() {
  return <JobOpeningLayout meta={foundingMarketingLead} />;
}
